import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { studyTimeTrackingService } from "@/infrastructure/services";

/** Query: Fetch weekly study time */
export const useWeeklyStudyTimeQuery = (startDate: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.STUDY_TIME.WEEKLY, startDate],
    queryFn: () => studyTimeTrackingService.getWeeklyStudyTime(startDate),
    enabled: !!startDate,
    staleTime: 60 * 1000, // 1 minute
    placeholderData: keepPreviousData,
  });
};
